import { reatomAsync } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { API } from "src/api.ts";
import { withIsLoadingAtom } from "src/common/pipes";
import { toastHandler } from "src/util";

import { getExportTasksRequest } from "./getExportTaskRequest";

export const createExportTasksRequest = reatomAsync(
  async (ctx) => {
    const response =
      await API.exporterQueueApi.exportControllerCreateExportTask({
        signal: ctx.controller.signal,
      });

    if (response.data) {
      toastHandler.success({
        name: "createExportTasks",
        title: "Добавление выгрузки",
        content: "Добавлена новая выгрузка",
      });
    }
  },
  {
    name: "createExportTasksRequest",
    onFulfill: (ctx) => getExportTasksRequest(ctx),
  },
).pipe(withAbort(), withIsLoadingAtom());
